// extracted by mini-css-extract-plugin
export var content = "_q3-1";
export var fullScreen = "_q3-0";